module.exports = __webpack_public_path__ + "static/img/iconmenu05.f97ee905.svg";